import axios from 'axios'
import { getAccessToken } from 'helpers/get-access-token'
import store from 'store'
import { logout } from 'store/authSlice'
import { setHttpMessage } from 'store/messageSlice'

const apiViaticos = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

apiViaticos.interceptors.request.use(async (config) => {
    const accessToken = getAccessToken()
    if (accessToken) {
        config.headers?.set?.('Authorization', `Bearer ${accessToken}`)
    }
    return config
})
apiViaticos.interceptors.response.use(
    (response) => {
        if (response.status === 401) {
            store.dispatch(logout())
            store.dispatch(
                setHttpMessage({
                    status: 401,
                    title: 'Su sesión a expirado',
                    detail: 'El tiempo de su sesión ha terminado o se ha iniciado sesión con su cuenta desde otro navegador.',
                    sticky: true,
                }),
            )
        }
        return formatResponse(response)
    },
    (error) => {
        return axios.isCancel(error)
            ? cancellationResponse
            : error.response
              ? formatResponse(error.response)
              : failureResponse
    },
)

// Respuesta de petición fallida.
const failureResponse = {
    data: { message: 'Fallo en la solicitud' },
    status: 500,
    statusText: 'Failed Request',
    success: false,
}
// Respuesta de petición cancelada.
const cancellationResponse = {
    data: { message: 'Solicitud Cancelada' },
    status: 499,
    statusText: 'Client Closed Request',
    success: false,
}
const formatResponse = (response) => {
    const { data, status, statusText } = response
    return { data, status, statusText }
}

export default apiViaticos
